module.exports = __webpack_public_path__ + "static/media/carroussel_13.8047cb87.jpg";